import WhatsAppEventModal from './WhatsAppEventModal';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tramite: any;
  onTramiteUpdated?: () => Promise<void> | void;
};

const WhatsAppEscrituraInscriptaModal = ({ open, onOpenChange, tramite, onTramiteUpdated }: Props) => {
  return (
    <WhatsAppEventModal
      open={open}
      onOpenChange={onOpenChange}
      tramite={tramite}
      onTramiteUpdated={onTramiteUpdated}
      eventType="escrituras.envio_escritura_inscripta"
      title="Enviar escritura inscripta por WhatsApp"
      description="Se enviará la escritura inscripta con enlace temporal seguro."
    />
  );
};

export default WhatsAppEscrituraInscriptaModal;
